<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="发货单"
      class="customer-edit"
      width="1200px"
      top="10vh">
    <el-table
        :data="tableData"
        style="width: 100%;margin-top: 20px"
        @select="selectTest"
        @select-all="selectAll">
      <el-table-column type="selection" align="center" width="55"/>
      <el-table-column align="center" prop="rowNO" label="行号" width="100"/>
      <el-table-column align="center" prop="materialNO" label="物料号"/>
      <el-table-column align="center" prop="materialName" label="物料描述"/>
      <el-table-column align="center" prop="quantity" label="数量" width="130px">
        <template slot-scope="scope">
          <el-input v-model="scope.row.quantity" type="number" min="1"/>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="unit" label="单位"/>
    </el-table>
    <span slot="footer">
      <el-button @click="dialogVisible=false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="submit">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>

  export default {
    name:"SalesDeliveryDataEdit",
    components: {},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        tableData:[],
        idList:[],
        billId: "0",
        billType: "0",
        sapsalesOrderNO: "",
        customerOuterNo: "",
        ruleValidate: {},
      };
    },
    methods: {
      open(billId,billType) {
        this.dialogVisible = true;
        this.billId = billId + "";
        this.billType = billType + "";
        this.getData();
      },
      async getData() {
        this.loading = true;
        let resp = await this.$http.get("basic", `sd/so/${this.billId}/0`);
        this.sapsalesOrderNO = resp.data.sapsalesOrderNO;
        this.customerOuterNo = resp.data.customerOuterNo;
        this.tableData = resp.data.salesOrderSAPMaterialVOes;
      },
      selectTest(selection) {
        this.idList = selection;
      },
      selectAll(selection) {
        this.idList = selection;
        console.log(selection);
      },
      submit() {
        if (this.idList.length === 0) {
          this.$message.error("请勾选");
        }else {
          let list=[];
          for (let item of this.idList) {
            let objet = {
              POSNR:item.rowNO,
              MATNR:item.materialNO,
              LFIMG:item.quantity,
              VRKME:item.unit,
              WERKS: "S100",
            };
            list.push(objet);
          }
          this.submitLoading = true;
          let reqDataDto = {
            RSQ_DATA:{
              I_HEAD:{
                VSTEL : 1000,
                VBELN : this.sapsalesOrderNO,
                KUNNR : this.customerOuterNo,
                XABLN : 1,
                IT_ITEM:list,
              },
            },
          };
          console.log(reqDataDto);
          this.$http
            .post("basic", "sap/createSInvoice", reqDataDto)
            .then((res) => {
              //console.log(res);
              if (res.success === false) {
                this.$message.error(res.message);
              }else {
                this.$message.success(res.message);
              }
              this.submitLoading = false;
              this.dialogVisible = false;
              this.$emit("save-success");
            })
            .catch(() => {
              this.submitLoading = false;
            });
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
